import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/pages/Home'
import ListPokemon from '@/components/pages/pokemon/List'
import PokemonDetails from '@/components/pages/pokemon/Details'
import ListAbilities from '@/components/pages/abilities/List'
import AbilityDetails from '@/components/pages/abilities/Details'
import WhyPokemonData from '@/components/pages/WhyPokemonData'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/pokemon/list',
      name: 'ListPokemon',
      component: ListPokemon
    },
    {
      path: '/pokemon/:identifier',
      name: 'Pokemon',
      component: PokemonDetails
    },
    {
      path: '/abilities',
      name: 'Abilities',
      component: ListAbilities
    },
    {
      path: '/ability/:identifier',
      name: 'Ability',
      component: AbilityDetails
    },
    {
      path: '/why-pokemon-data',
      name: 'Why I made this site',
      component: WhyPokemonData
    }
  ]
})
